import { AppDispatch } from "../../../store/store";
import userService from "../services/user.service";
import {
  fetchProfile,
  profileFetched,
  fetchProfileFailure,
} from "../reducers/userProfileReducer";

export const fetchUserProfile = () => async (dispatch: AppDispatch) => {
  dispatch(fetchProfile());
  await userService
    .getUserProfile()
    .then((response) => {
      dispatch(profileFetched(response?.data ?? undefined));
    })
    .catch(() => {
      dispatch(fetchProfileFailure("Failed to load profile"));
    });
};
